module.exports = __webpack_public_path__ + "static/media/vaccine.cb8abfb7.jpeg";